import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SET_COMMENT, REMOVE_COMMENT, RESOLVE_COMMENT, UPDATE_COMMENT, GET_CHANGELOG_BY_ID, GET_ALL_COMMENT } from 'store/key';
import useDialog from "components/ConfirmDialog/useDialog";

const useComment = () => {
    const { isShow, isShowViewOnly, questionField, commentDetail } = useSelector(state => state.comment.commentBox);
    const { changeLog } = useSelector(state => state.comment);
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [comment, setComment] = useState("");
    const [isShowChangeHistory, setIsShowChangeHistory] = useState(false);
    const showDialog = useDialog();

    const onClose = () => {
        dispatch({
            type: SET_COMMENT,
            payload: {
                commentBox: {
                    commentId: null,
                    viewOnly: false,
                    isShow: false
                }
            }
        });
    }

    const handleSave = (payload) => {
        // Save comment logic
        dispatch({
            type: UPDATE_COMMENT,
            payload,
        });
        onClose();
    };

    const onChangeComment = (e) => {
        setComment(e.target.value);
    };

    const onOpenChangeHistory = (id) => {
        setIsShowChangeHistory(true);
        dispatch({ type: GET_CHANGELOG_BY_ID, payload: id });
    }

    const onCloseChangeHistory = () => {
        setIsShowChangeHistory(false);
    }

    const handleDelete = (payload, closePopup, cb) => {
        closePopup();
        showDialog({
            description: 'Confirm to delete the comment?',
            callback: () => {
                cb();
                dispatch({
                    type: REMOVE_COMMENT,
                    payload
                });
            }
        });
    }

    const handleResolve = (payload, closePopup, cb) => {
        showDialog({
            description: 'Confirm to resolve the comment?',
            callback: () => {
                cb();
                dispatch({
                    type: RESOLVE_COMMENT,
                    payload,
                });
            }
        });
    }

    const handleUpdate = (payload) => {
        dispatch({
            type: UPDATE_COMMENT,
            payload,
        });
    }

    const handleGetAllComments = (formId) => {
        dispatch({
            type: GET_ALL_COMMENT,
            payload: formId,
        });
    }

    return {
        comment,
        onChangeComment,
        isShow,
        isShowViewOnly,
        user,
        handleSave,
        onClose,
        isShowChangeHistory,
        onOpenChangeHistory,
        onCloseChangeHistory,
        questionField,
        commentDetail,
        handleDelete,
        handleResolve,
        handleUpdate,
        changeLog,
        handleGetAllComments,
    };
};

export default useComment;